// extracted by mini-css-extract-plugin
module.exports = {"disconnectBtn":"disconnectButton_disconnectBtn__3zxF0","disconnectBtnText":"disconnectButton_disconnectBtnText__3b1Oj"};